export default () => ({
  getTimes: false,
  to: {
    agenda_id: null,
    schedule_id: null
  },
  errors: {},
  date: null,
  dates: [],
  times: []
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/active-agenda/components/transfer/resources/data.js